<template>
  <span>
    <el-button v-if="!isLink" @click="optIn" class="opt-in-button" size="small">{{ optionText || $t('common.optIn') }}</el-button>
    <a v-else @click="optIn" :class="optionText ? 'blue-link-bold' : 'red-link-bold'" href="#" v-html="optionText || $t('common.here')"></a>
    <el-dialog
        id="charge-code-detail-dialog"
        :visible.sync="dialogVisible"
        width="70%"
        :title="$t('common.licenseAgreementTitle')"
        :close-on-click-modal="false"
        append-to-body
    >
      <el-row>
        <el-tabs>
          <el-tab-pane :label="$t('common.licenseAgreementContent')">
            <div style="max-height: 400px; width: 100%; overflow-y: auto; padding: 10px; border: 1px solid #ccc; border-radius: 4px;">
              <pre style="white-space: pre-wrap; text-wrap: auto; ">{{ privacyPolicy() }}</pre>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('common.termsAndConditionsContent')">
            <div style="max-height: 400px; width: 100%; overflow-y: auto; padding: 10px; border: 1px solid #ccc; border-radius: 4px;">
              <pre style="white-space: pre-wrap; text-wrap: auto; ">{{ termsAndConditions() }}</pre>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-checkbox v-model="acceptLicense">{{ $t('common.acceptPrivacyPolicy') }}</el-checkbox>
          <el-checkbox v-model="acceptAgreement">{{ $t('common.acceptTermsAndConditions') }}</el-checkbox>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20" class="text-align-end">
          <el-button :disabled="!(acceptLicense && acceptAgreement)" @click="close" class="opt-in-button" size="small">{{ $t('common.save') }}</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </span>
</template>
<script>
import agreements from '@/utils/agreements';
import accountService from '@/api/accountService';

export default {
  name: 'AgreementDialog',
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    currentPhone: {
      type: String,
      required: false,
    },
    isLink: {
      type: Boolean,
      default: false,
      required: false,
    },
    optionText: {
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      acceptLicense: false,
      acceptAgreement: false,
    };
  },
  methods: {
    optIn() {
      this.dialogVisible = true;
    },
    privacyPolicy() {
      return agreements.privacyPolicy;
    },
    termsAndConditions() {
      return agreements.termsAndConditions;
    },
    close() {
      if (this.acceptLicense && this.acceptAgreement) {
        // Aquí puedes agregar la lógica para manejar la aceptación de los términos

        this.$prompt('Please input your phone number', 'Tip', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          inputValue: this.currentPhone || '',
        }).then(({ value }) => {
          accountService.acceptSendSms(this.accountId, value)
            .then(() => {
              this.dialogVisible = false;
              this.$message.success(this.$t('common.optInSuccess'));
            })
            .catch((error) => {
              this.$message.error(error || this.$t('common.optInError'));
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Input canceled'
          });
        });
        /* */
      }
    },
  }
};
</script>
